import React from "react";
import { useI18n } from "@/i18n";
import { Instagram, ArrowUp } from "lucide-react";

const INSTAGRAM =
  "https://www.instagram.com/sue__production?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
const TIKTOK = "https://www.tiktok.com/@sue_production?is_from_webapp=1&sender_device=pc";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid lg:grid-cols-[2fr_1fr_1fr_1fr] gap-12 lg:gap-16 mb-20">
          <div>
            <div className="font-display text-3xl md:text-4xl tracking-tight font-light mb-5">
              SUE<span className="opacity-50"> · </span>
              <span className="font-semibold">PRODUCTION</span>
            </div>
            <p className="text-white/55 max-w-sm">{t.footer.tagline}</p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href={INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full luxury-glass flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href={TIKTOK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok"
                aria-label="TikTok"
                className="w-10 h-10 rounded-full luxury-glass flex items-center justify-center hover:bg-white hover:text-black transition-colors"
              >
                <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.94a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.84-.31z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-5">
              {t.footer.sections.explore}
            </div>
            <ul className="space-y-3 text-white/65">
              <li>
                <button onClick={() => go("services")} className="hover:text-white transition-colors">
                  {t.nav.services}
                </button>
              </li>
              <li>
                <button onClick={() => go("portfolio")} className="hover:text-white transition-colors">
                  {t.nav.portfolio}
                </button>
              </li>
              <li>
                <button onClick={() => go("process")} className="hover:text-white transition-colors">
                  {t.nav.process}
                </button>
              </li>
              <li>
                <button onClick={() => go("quote")} className="hover:text-white transition-colors">
                  {t.nav.contact}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-5">
              {t.footer.sections.contact}
            </div>
            <ul className="space-y-3 text-white/65">
              <li>
                <a
                  href="mailto:josuesevilla26sep@gmail.com"
                  data-testid="footer-email"
                  className="hover:text-white transition-colors"
                >
                  josuesevilla26sep@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+14075419482"
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  +1 (407) 541-9482
                </a>
              </li>
              <li className="text-white/45">Miami · Tulsa · Dallas</li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-5">
              {t.footer.sections.legal}
            </div>
            <ul className="space-y-3 text-white/65">
              <li>{t.footer.privacy}</li>
              <li>{t.footer.terms}</li>
            </ul>
          </div>
        </div>

        <div className="font-display text-[18vw] md:text-[14vw] leading-none tracking-tighter text-white/[0.04] select-none -mb-6 overflow-hidden whitespace-nowrap">
          SUE · PRODUCTION
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10 text-xs text-white/40">
          <div>© {year} Sue Production. {t.footer.rights}</div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top"
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            <ArrowUp size={14} />
            {t.common.back_to_top}
          </button>
        </div>
      </div>
    </footer>
  );
}
